import React, { useState, useEffect } from 'react';
import A4Page from '../A4Page';
import TopDetail from '../TopDetail';
import Page1 from './Page1';
import ZorluPage1 from './Zorlu';
import Page2 from './Page2';

const L120_25New = ({ data, selectColor, tab }, ref) => {
  const [isRug, setIsRug] = useState(false);
  const [isHursan, setIsHursan] = useState(false);
  const [isZorlu, setIsZorlu] = useState(false);


  const [filteredAndGroupedSizes, setFilteredAndGroupedSizes] = useState([]);



  useEffect(() => {
    const variant = data?.sizeGroup?.variant;
    setIsHursan(data.companyId==="6562742a5b252fdddcc588e9")
    setIsRug(variant === 'rug');
  }, [data?.sizeGroup?.variant]);

  useEffect(() => {
    const variant = data?.sizeGroup?.variant;
    if (!variant) return;

    let number = 3;            // default grup başına adet
    if (variant === 'rug') number = 1;

    const sizes =
      data?.washingLabel?.[selectColor]?.sizes
        ?.filter(item => item?.amount > 0)
        ?.reduce((acc, item, index) => {
          const groupIndex = Math.floor(index / number);
          if (!acc[groupIndex]) acc[groupIndex] = [];
          acc[groupIndex].push(item);
          return acc;
        }, []) || [];
       
    setIsZorlu(data.company.name.includes("ZORLUTEKS TEKSTİL"))
    setFilteredAndGroupedSizes(sizes);
  }, [data?.washingLabel, selectColor, data?.sizeGroup?.variant]);



  const makeBarcode = (sizeData) => {
    const [p0 = '', p1 = ''] = (data?.articleNo || '').split('/');
    const color = data?.washingLabel?.[selectColor]?.colorCode || '';
    const sCode = sizeData?.sCode || '';
    return `4${p0}${p1}${color}${sCode}`;
  };

  return (
    <>
      {isRug ? (
        <div className="flex flex-col items-center" ref={ref}>
          {filteredAndGroupedSizes.map((group, groupIndex) => (
            <A4Page key={groupIndex} type={isHursan ? "yatay" : "dikey"}>
              <div className="space-y-5">
                <TopDetail values={data} selectColor={selectColor} tab={tab} />
                <div
                  className="space-y-3"
                  style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                >
                  {group.map((sizeData, index) => (
                    <React.Fragment key={sizeData?.sCode || sizeData?.id || `${groupIndex}-${index}`}>
                      {isZorlu ? (
                        <ZorluPage1
                          isHursan={isHursan}
                          isZorlu={isZorlu}
                          selectColor={selectColor}
                          barcodeValue={makeBarcode(sizeData)}
                          data={data}
                          sizeData={sizeData}
                        />
                      ) : (
                        <Page1
                          isHursan={isHursan}
                          isZorlu={isZorlu}
                          selectColor={selectColor}
                          barcodeValue={makeBarcode(sizeData)}
                          data={data}
                          sizeData={sizeData}
                        />
                      )}
                      {/* Page2, prop adı talebe göre: SizeData */}
                      
                      <Page2 data={data} tab={tab} SizeData={sizeData} isHursan={isHursan} isZorlu={isZorlu} />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </A4Page>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center" ref={ref}>
          {filteredAndGroupedSizes.map((group, groupIndex) => {
            const lastSize = group?.[group.length - 1]; // ihtiyacına göre first/median seçebilirsin
            return (
              <A4Page  key={groupIndex} type={isHursan ? "yatay" : "dikey"}>
                <div className="space-y-5">
                  <TopDetail values={data} selectColor={selectColor} tab={tab} />
                  <div
                    className="space-y-3"
                    style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                  >
                    {group.map((sizeData, index) => (
                      isZorlu ? (
                        <ZorluPage1
                          isHursan={isHursan}
                          isZorlu={isZorlu}
                          key={sizeData?.sCode || sizeData?.id || `${groupIndex}-${index}`}
                          selectColor={selectColor}
                          barcodeValue={makeBarcode(sizeData)}
                          data={data}
                          sizeData={sizeData}
                        />
                      ) : (
                        <Page1
                          isHursan={isHursan}
                          isZorlu={isZorlu}
                          key={sizeData?.sCode || sizeData?.id || `${groupIndex}-${index}`}
                          selectColor={selectColor}
                          barcodeValue={makeBarcode(sizeData)}
                          data={data}
                          sizeData={sizeData}
                        />
                      )
                    ))}
                    {/* Map DIŞINDA: açıkça bir SizeData seçip gönder */}
                    {lastSize ? <Page2 data={data} tab={tab} SizeData={lastSize} isHursan={isHursan} isZorlu={isZorlu} /> : null}
                  </div>
                </div>
              </A4Page>
            );
          })}
        </div>
      )}
    </>
  );
};

export default React.forwardRef(L120_25New);
